import {
  CreateNotifications,
  NotificationCount,
  NotificationFilters,
  NotificationListResponse,
} from '@/types/notification.type';
import axios from 'axios';
import api from '../instance';
export const API_URL = `/notifications`;

const getToken = () => localStorage.getItem('accessToken');

export const notificationManagementService = {
  createNotification: async (data: CreateNotifications | FormData) => {
    try {
      const res = await api.notificationApi.post(`${API_URL}/create`, data, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error creating notification');
    }
  },
  resendNotification: async (id: string | FormData) => {
    try {
      const res = await api.notificationApi.post(`${API_URL}/resend-failed/${id}`, null, {
        headers: {
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error creating notification');
    }
  },
  getNotificationsList: async (
    filters?: NotificationFilters,
  ): Promise<NotificationListResponse> => {
    try {
      const res = await api.notificationApi.get<NotificationListResponse>(`${API_URL}/all`, {
        params: filters,
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error get notifications list');
    }
  },

  getNotificationById: async (id: string) => {
    try {
      const res = await axios.get(`${API_URL}${id}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error get notification by id');
    }
  },

  updateNotification: async (id: string, data: CreateNotifications | FormData) => {
    try {
      const res = await api.notificationApi.put(`${API_URL}/${id}`, data, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error update notification');
    }
  },

  deleteNotification: async (id: string, deletedBy: string) => {
    try {
      const res = await axios.delete(`${API_URL}${id}`, {
        params: { deletedBy },
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error delete notification');
    }
  },
  getNotificationInfo: async (): Promise<NotificationCount> => {
    try {
      const res = await api.notificationApi.get<NotificationCount>(`${API_URL}/count`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error get Notfication info');
    }
  },

  exportNotifications: async () => {
    try {
      const res = await api.notificationApi.get(`${API_URL}/bulk-export`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error exporting Notifications');
    }
  },
};
